var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNameLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 54,
    viewBox: "0 0 200 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_5640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9446 3.04222C54.6676 0.991329 52.1351 0.180605 51.5532 0.164551C50.8227 0.144483 10.3146 0.164551 10.3146 0.164551L0.156494 32.156H13.6258L14.7214 28.5198L34.235 28.58L30.4543 40.5362H43.8473L54.7279 6.04431C54.9514 5.06032 55.0245 4.04812 54.9446 3.04222ZM37.1127 19.3811L17.6593 19.3691L20.7858 9.59223H40.2151L37.1127 19.3811Z",
    fill: "#006AB7",
    stroke: "#006AB7",
    strokeWidth: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.844 0.97126H156.57L153.343 10.5876H169.229L158.561 44.4012L30.0129 44.2647L27.1553 53.7245L189.934 53.7526L193.458 44.4895L172.279 44.4654L181.839 10.5836L196.601 10.5876L199.844 0.97126Z",
    fill: "#006AB7",
    stroke: "#006AB7",
    strokeWidth: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.443 8.78151C103.817 10.9568 102.239 14.866 102.239 14.866L94.7983 40.6646L82.4689 40.7088L89.6932 15.6927H79.82L69.4813 40.7289H54.2742L65.3594 15.7208H57.1759L60.0375 6.42158H69.2686L72.0459 0.136462L86.1814 0.112381L83.8215 6.42158L98.2178 6.46573C98.2178 6.46573 103.006 6.20886 103.443 8.78151Z",
    fill: "#006AB7",
    stroke: "#006AB7",
    strokeWidth: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.536 29.9045L133.432 40.7409H146.889V40.781L136.755 19.333L148.655 6.4577L148.904 6.15268C148.904 6.15268 150.185 5.01285 149.884 2.65292C149.558 0.0762599 147.596 0.124422 147.596 0.124422L110.491 0.136462L107.369 9.41965H127.733L101.2 40.6687H117.756L127.536 29.8724",
    fill: "#006AB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.536 29.9045L133.432 40.7409H146.889V40.781L136.755 19.333L148.655 6.4577L148.904 6.15268C148.904 6.15268 150.185 5.01285 149.884 2.65292C149.558 0.0762599 147.596 0.124422 147.596 0.124422L110.491 0.136462L107.369 9.41965H127.733L101.2 40.6687H117.756L127.536 29.8724",
    stroke: "#006AB7",
    strokeWidth: 0.57
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_5640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 53.869,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNameLogo);
export default __webpack_public_path__ + "static/media/icon_name_logo.1667a596736cb640029a699808201a59.svg";
export { ForwardRef as ReactComponent };